/**
 * Routes where study time should be tracked.
 * Uses route path prefixes -- any pathname starting with these is trackable.
 */
export const TRACKABLE_ROUTE_PREFIXES = ["/study", "/vocabulary", "/mock-exam"] as const;

/**
 * Exact routes to EXCLUDE even if they match a prefix above.
 * (None currently needed, but extensible.)
 */
export const EXCLUDED_ROUTES: string[] = [];

/** Heartbeat interval in milliseconds */
export const HEARTBEAT_INTERVAL_MS = 30_000; // 30 seconds

/** Idle timeout: pause tracking after no user activity for this duration */
export const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Check if a pathname is a trackable study route.
 * Matches against prefix list, then checks exclusions.
 */
export const isTrackableRoute = (pathname: string): boolean => {
  if (EXCLUDED_ROUTES.includes(pathname)) return false;
  return TRACKABLE_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};
